"use strict";
/* globals module */
/**
 * @module filesStreamsRoute
 * @description Baasic Files Streams Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
var contracts_1 = require("../../core/contracts");
var FilesStreamsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(FilesStreamsRoute, _super);
    function FilesStreamsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'file-streams/{id}/{?width,height,t}';
        _this.updateRoute = 'file-streams/{id}/{?width,height}';
        _this.createRoute = 'file-streams/{path}';
        return _this;
    }
    /**
     * Parses get route; this route should be expanded with id or path of desired file stream. Additional supported items are:
     * - `width` - width of desired derived image.
     * - `height` - height of desired derived image.
     * - `t` - cache invalidation param.
     * @method
     * @example filesStreamsRoute.get({id: '<path>'});
     **/
    FilesStreamsRoute.prototype.get = function (data) {
        if (!this.utility.isObject(data)) {
            data = {
                id: data
            };
        }
        return _super.prototype.baseCreate.call(this, this.getRoute, data);
    };
    /**
     * Parses update route; this route should be expanded with the id or path of the previously saved resource. Additional supported items are:
     * - `width` - width of derived image to update.
     * - `height` - height of derived image to update.
     * @method
     * @example filesStreamsRoute.update({id: '<path>'});
     **/
    FilesStreamsRoute.prototype.update = function (data) {
        if (!this.utility.isObject(data)) {
            data = {
                id: data
            };
        }
        return _super.prototype.baseCreate.call(this, this.updateRoute, data);
    };
    /**
     * Parses create route; this route should be expanded with the path which indicates where the stream will be saved.
     * @method
     * @example filesStreamsRoute.create({path: '<path>'});
     **/
    FilesStreamsRoute.prototype.create = function (data) {
        if (!this.utility.isObject(data)) {
            data = {
                path: data
            };
        }
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    var _a;
    FilesStreamsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], FilesStreamsRoute);
    return FilesStreamsRoute;
}(common_1.BaseRoute));
exports.FilesStreamsRoute = FilesStreamsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
